import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { CircleIcon, CalendarIcon, ZapIcon, StarIcon } from 'lucide-react';
const pillars = [{
  icon: CircleIcon,
  title: 'Círculos Privados',
  description: 'Espacios de conexión profunda por ruta'
}, {
  icon: CalendarIcon,
  title: 'Eventos en Vivo',
  description: 'Encuentros virtuales y presenciales'
}, {
  icon: ZapIcon,
  title: 'Desafíos',
  description: 'Retos de 7-30 días para implementar'
}, {
  icon: StarIcon,
  title: 'Acceso Anticipado',
  description: 'Primero en conocer todo lo nuevo'
}];
export function Community() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="comunidad" ref={ref} className="py-24 md:py-32 bg-beige" data-id="element-63">
      <div className="max-w-6xl mx-auto px-6" data-id="element-64">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center mb-12" data-id="element-65">
          <p className="font-sans text-sm uppercase tracking-widest text-gold mb-4" data-id="element-66">
            Pertenencia
          </p>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-charcoal mb-6" data-id="element-67">
            La Comunidad
          </h2>
          <p className="font-sans text-lg text-charcoal-mid font-light max-w-xl mx-auto" data-id="element-68">
            No es un grupo de Facebook. Es un círculo de expansión.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="bg-white rounded-3xl p-8 md:p-12 mb-12" data-id="element-69">
          <p className="font-sans text-lg text-charcoal-mid text-center leading-relaxed max-w-3xl mx-auto" data-id="element-70">
            Aquí no vienes a consumir contenido. Vienes a pertenecer a algo más
            grande. A crecer con personas que, como tú, eligieron una vida
            diferente.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12" data-id="element-71">
          {pillars.map((pillar, index) => <motion.div key={pillar.title} initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.3 + index * 0.1,
          ease: 'easeOut'
        }} className="bg-white rounded-2xl p-6 text-center" data-id="element-72">
              <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-gold/10 flex items-center justify-center" data-id="element-73">
                <pillar.icon className="w-6 h-6 text-gold" data-id="element-74" />
              </div>
              <h3 className="font-serif text-lg text-charcoal mb-2" data-id="element-75">
                {pillar.title}
              </h3>
              <p className="font-sans text-sm text-charcoal-mid" data-id="element-76">
                {pillar.description}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8,
        delay: 0.7
      }} className="text-center" data-id="element-77">
          <button className="px-10 py-4 bg-charcoal text-cream font-sans font-medium rounded-full hover:bg-charcoal-mid transition-colors duration-300" data-id="element-78">
            Unirme a la comunidad
          </button>
        </motion.div>
      </div>
    </section>;
}